"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var googleAnalyticsManager_1 = require("./google/googleAnalyticsManager");
var internalAnalytics_1 = require("./internal/internalAnalytics");
exports.AnalyticsService = {
    initialise: function (config) {
        googleAnalyticsManager_1.GoogleAnalytics.initialise(config.google);
        internalAnalytics_1.InternalAnalytics.initialise(config.internal);
    },
    recordEvent: function (action) {
        googleAnalyticsManager_1.GoogleAnalytics.recordEvent(action);
        internalAnalytics_1.InternalAnalytics.recordEvent(action);
    },
    recordPageview: function (path) {
        googleAnalyticsManager_1.GoogleAnalytics.recordPageview(path);
    },
};
